<template>
  <div class="detail-box">
    <share></share>
    <div class="introduction-box">
      <div class="introduction">
        <div class="cont">
          <span class="head"><img :src="nowData.img2" alt=""></span>
          <div class="content">
            <span class="name">{{nowData.name}}</span>
            <span class="txt">{{nowData.job}}</span>
            <span v-show="ting" class="ting">{{nowData.ting}}人在听</span>
          </div>
        </div>
        <div class="share" @click="share(nowData.id)">分享</div>
      </div>
      <!-- <div class="basic">
        <div class="icon w3"><img src="./../assets/xz.png" alt="" srcset=""></div>
        <div class="icon w3"><img src="./../assets/xx.png" alt="" srcset=""></div>
        <div class="icon w4"><img src="./../assets/info.png" alt="" srcset=""></div>
      </div><div class="basic">
        <div class="name w3 b-right">{{nowData.constellation}}</div>
        <div class="name w3 b-right">{{nowData.bloodType}}</div>
        <div class="name w4 info">{{nowData.info}}</div>
      </div> -->
      <div class="basic">
          <div class="basic-box flex border-right">
            <div class="icon"><img src="./../assets/xz.png" alt="" srcset=""></div>
            <div class="name">{{nowData.constellation}}</div>
          </div>
          <div class="basic-box flex">
            <div class="icon"><img src="./../assets/xx.png" alt="" srcset=""></div>
            <div class="name">{{nowData.bloodType}}</div>
          </div>
      </div>
      <div class="basic-box info-box">
        <div class="icon"><img src="./../assets/info.png" alt="" srcset=""></div>
        <div class="info-name">{{nowData.info}}</div>
      </div>
    </div>
    <div class="problem">
      <div class="problem-box" v-for="(item,index) in nowData.problem">
        <div class="tit">Q{{index+1}}：{{item.title}}？</div>
        <div class="content">
          <div class="audio-box-detali">
            <audioTemplate :music="item.music" :index="index" @playMusic="playMusic"></audioTemplate>
          </div>
          <span :class="['thumbs',getActive(item)?'active':'']" @click="tapzan(index)">{{item.thumbs}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import audioTemplate from "./audio"
import data from "@/assets/data.js"
import {AddThumbs,GetList} from "@/api.js"
import share from "./share"

export default {
  name: 'redWoodDetail',
	components: {
    audioTemplate,
    share,
  },
  data () {
    return {
      data,
      nowData: {},
      ting: false,
    }
  },
  beforeRouteUpdate(to, from, next) {
    let id = to.params.id
    this.fetch(id)
    next();
  },
  mounted () {
    let id = this.$route.params.id;
    this.fetch(id)
  },
  methods: {
    getActive(obj) {
      let indexData = localStorage.getItem('all_data_s');

      let status = false;
      if(indexData){
        let data = JSON.parse(indexData)
        
        data.forEach((item,index) => {

          if(item.id == this.nowData.id){
            item.problem.forEach((val,ind) => {
              if(val.id == obj.id){
                status = true;
              }
            })
          }
        })
      }
      return status || obj.fabulous;
    },
    fetch(id){
      let indexData = localStorage.getItem(id)

      if(indexData){
        let nowData = JSON.parse(indexData)
        this.nowData = nowData
      }
      else{
        this.data.forEach(item => {
          if(item.id == id){
            this.nowData = item
          }
        })
      }

      GetList({type_id: 2,size:10000}).then(res => {
        if(res.code == 0){
          let data = res.data
          this.nowData.ting = 0
          data.forEach((item,index) => {
            if(item.content_id.length > 3){
              let arr = item.content_id.split('_')
              if(id == arr[0]){
                this.nowData.problem.forEach((name,key) => {
                  if(name.id == arr[1]){
                    name.thumbs = item.data
                    this.nowData.ting += item.data
                  }
                })
              }
            }
          })
          this.ting = true
        }
      })
      
    },
    playMusic(e){
      this.nowData.problem.forEach((item,index) => {
        if(index == e){
          item.music.speaking = true
        }
        else{
          item.music.speaking = false
        }
      })
    },
    share(id){
      this.$router.push({name: 'posterDetail',params: { id: id}})
    },
    hasID(data,id){

      for(var i=0;i<data.length;i++){
        if(data[i].id == id){
          return i
        }
      }
      return -1
    },
    tapzan(index){
      let content_id = this.nowData.id +'_'+ this.nowData.problem[index].id
      let addData = {
        type_id: 2,
        content_id: content_id
      }
      AddThumbs(addData).then(res => {
        if(res.code == 0){
          this.nowData.problem[index].fabulous = true
          this.nowData.problem[index].thumbs +=1

          let indexData = localStorage.getItem('all_data_s');
          let data = []
          if(indexData){
            data = JSON.parse(indexData)
          }

          let json = {}
          json.problem = []

          this.nowData.problem.forEach((name,key) => {
            if(name.fabulous){

              let a = {}
              a.id = name.id
              a.fabulous = true

              let index_id = this.hasID(data,this.nowData.id)

              if(index_id != -1){

                if(this.hasID(data[index_id].problem,a.id) == -1){
                  data[index_id].problem.push(a)
                }
                
              }
              else{
                json.id = this.nowData.id
                json.problem.push(a)
                data.push(json)
              }
            }
          })

          let str = JSON.stringify(data)

          localStorage.setItem('all_data_s',str)
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.border-right{
  border-right: 1px solid #e3e3e3;
}
.flex{
  display: flex;
  justify-content: center;
}
.basic-box{
  width: 50%;
  box-sizing: border-box;
  .icon{
    height: .3rem;
    img{
      height: 100%;
      display: block;
    }
  }
  &.info-box{
    width: 100%;
    display: flex;
    padding-top: .2rem;
    border-top: 1px solid #e3e3e3;
    align-items: center;
    .info-name{
      font-size: .22rem;
      padding-left: .2rem;
      text-align: left;
    }
  }
}
.problem{
  background: #fff;
  padding: 0 .3rem .2rem;
  margin-top: .5rem;
  border-radius: 5px;
  box-shadow: 0px 0px 20px rgba(162,219,216,0.6);
  .problem-box{
    padding: .35rem 0 .4rem;
    border-bottom: 1px solid #ededed;
    &:last-child{
      border-bottom: none;
    }
    .tit{
      font-size: .27rem;
      font-weight: bold;
      text-align: left;
      color: #333;
    }
  }
  .content{
    position: relative;
    padding-top: .26rem;
    .audio-box-detali{
      width: 5rem;
    }
    .thumbs{
      position: absolute;
      right: 0;
      top: .36rem;
      background: url('./../assets/zan.png') no-repeat;
      background-size: .3rem;
      padding-left: .4rem;
      font-size: .22rem;
      color: #d9d9d9;
      &.active{
        color: #ff702a;
        background: url('./../assets/zaning.png') no-repeat;
        background-size: .3rem;
      }
    }
  }
}
.detail-box{
  background: linear-gradient(to bottom, #fff , rgba(162,219,216,0.2));
  padding: .4rem;
  min-height: 100vh;
  box-sizing: border-box;
}
.introduction-box{
  box-sizing: border-box;
  padding: .34rem .3rem;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 20px rgba(162,219,216,0.6);
  .basic{
    display: flex;
    color: #333;
    font-size: .22rem;
    padding-bottom: .2rem;
    .w3{
      width: 22%;
    }
    .w4{
      width: 56%;
    }
    .b-right{
      position: relative;
      &:after{
        position: absolute;
        top: -0.15rem;
        right: 0;
        content: '';
        width: 1px;
        height: 100%;
        background: #ededed;
      }
    }
    .info{
      padding-left: .2rem;
      overflow: hidden;
      text-overflow:ellipsis;
      display: -webkit-box;
      -webkit-line-clamp:2;
      -webkit-box-orient: vertical;
    }
    .name{
      // padding-top: .16rem;
      min-width: 1.2rem;
      max-height: .68rem;
    }
  }
  .introduction{
    display: flex;
    justify-content: space-between;
    .share{
      width: 1.18rem;
      height: .5rem;
      line-height: .52rem;
      color: #fff;
      margin-top: .68rem;
      font-size: .26rem;
      box-sizing: border-box;
      border-radius: 4px;
      padding-left: .4rem;
      background: url('./../assets/share.png') .16rem .12rem no-repeat #5bb65d;
      background-size: .26rem;
    }
  }
  .cont{
    display: flex;
    position: relative;
    align-items: center;
    padding: .26rem 0 .3rem;
    .head{
      display: block;
      width: 1.3rem;
      height: 1.3rem;
      overflow: hidden;
      border-radius: 50%;
      // border: .06rem solid #e0e0e0;
      margin-right: .2rem;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .content{
      color: #333;
      text-align: left;
      // width: calc(100% - 1.52rem);
      .name{
        font-size: .36rem;
        font-weight: bold;
        display: block;
      }
      .txt{
        font-size: .22rem;
        line-height: .4rem;
        display: block;
      }
      .ting{
        font-size: .22rem;
        line-height: .4rem;
        color: #5bb65d;
        display: block;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/detail.vue